var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { CartPaymentCard } from "../card/Card";
import { cartPaymentInfoCls, cartPaymentInfoCardsCls, cartPaymentInfoCardsListCls, cartPaymentInfoInstalmentsCls } from "./OptionsInfo.less";
function CartPaymentOptionsInfo(_ref) {
  var instalmentsDescription = _ref.instalmentsDescription, paymentOptionsLabel = _ref.paymentOptionsLabel, _ref$cards = _ref.cards, cards = _ref$cards === void 0 ? [] : _ref$cards;
  return /* @__PURE__ */ React.createElement("div", {
    className: cartPaymentInfoCls
  }, /* @__PURE__ */ React.createElement("div", {
    className: cartPaymentInfoCardsCls
  }, /* @__PURE__ */ React.createElement("span", null, paymentOptionsLabel), /* @__PURE__ */ React.createElement("ul", {
    className: cartPaymentInfoCardsListCls
  }, cards && cards.length ? cards.map(function(card) {
    return /* @__PURE__ */ React.createElement(CartPaymentCard, {
      key: card,
      tagName: "li",
      type: card
    });
  }) : null)), instalmentsDescription ? /* @__PURE__ */ React.createElement("div", {
    className: cartPaymentInfoInstalmentsCls
  }, instalmentsDescription) : null);
}
__name(CartPaymentOptionsInfo, "CartPaymentOptionsInfo");
export {
  CartPaymentOptionsInfo
};
